import MarkHomeworkDayView from './component';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import { isMarkable } from 'data/PaperBasedHomework/accessors';
import SessionNav from 'containers/Group/SessionNav';
import ViewNav from 'components/ViewNav';
import { getFirstUnitOfSession } from 'data/SessionPlans/accessors';

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'session-nav': {
        component: SessionNav,
        order: 1,
      },
      'view-nav': {
        component: ViewNav,
        order: 2,
        props: {
          hideExpandable: false,
        },
      },
    },
  },
  path: 'day(/:mode)',
  view: 'day',
  component: MarkHomeworkDayView,
  sessionNavConfig: {
    setModeOnNavigate: '',
  },
  actionButtons: {
    default: {
      Mark: {
        isPrimary: true,
        route: './edit',
        canAccess: () => PrivilegeChecker.hasPrivilege(getState(), Privileges.Homework.Mark),
        visibleWhen: ({ params: { sessionPlanId, groupId } }) =>
          (isMarkable(getState(), groupId, sessionPlanId) &&
            PrivilegeChecker.hasPrivilege(getState(), Privileges.Homework.Mark)),
      },
      'View content': {
        route: ({ params }) => {
          const { sessionPlanId, groupId } = params;
          const unitId = getFirstUnitOfSession(getState(), sessionPlanId);
          return `/group/${groupId}/assign-homework/session/${sessionPlanId}/unit/${unitId}`;
        },
        canAccess: () => PrivilegeChecker.hasPrivilege(getState(),
            Privileges.Homework.ViewAssignments),
        visibleWhen: () => PrivilegeChecker.hasPrivilege(getState(),
            Privileges.Homework.ViewAssignments),
      },
    },
    edit: {
      Save: {
        isPrimary: true,
        route: '../save',
      },
      Discard: {
        route: '../discard',
      },

    },
  },
});



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkDayView/routes.js